export default __webpack_public_path__ + "static/media/logo.160a6740.png";